<template>
  <div>
    <ASelect
      :show-search="true"
      v-model="input"
      placeholder="مقدار"
      style="width: 200px"
      :default-active-first-option="false"
      :show-arrow="true"
      :filter-option="false"
      :not-found-content="null"
      class="w-full"
      @search="fetch"
      @change="search"
    >

      <template #notFoundContent>
        <div>
          هیچ موردی یافت نشد
        </div>
      </template>
      <ASelectOption v-for="item in data" :key="item.id" :value="item.id">
        {{ item.title }}
      </ASelectOption>
    </ASelect>
  </div>
</template>

<script>
import axios from "@/axios";


export default {
  name: 'QuerySelectTableFilter',
  props: ['value', 'action'],
  data() {
    return {
      input: undefined,
      data: [],
    }
  },
  methods: {
    search() {
      this.$emit('input', this.input)

    },
    async fetch(value) {
      try {
        if (!value || value.length < 2) return;
        const {data} = await axios.get('/te/query', {params: {action: this.action , query:value}});
        this.data = data;
      } catch (e) {

        this.$message.error('خطا در دریافت اطلاعات');
      }
    }
  },
  mounted() {
    this.input = this.value
  }
}
</script>
